const goalSchema = [
  {
    name: 'name',
    label: 'Name',
    type: 'text',
    required: true,
    showInList: true,
  },
  {
    type: 'group',
    fields: [
      {
        name: 'targetValue',
        label: 'Target Value',
        type: 'text',
        showInList: true
      },
      {
        name: 'deadline',
        label: 'Deadline',
        type: 'date',
        showInList: true
      }
    ]
  },
    {
    type: 'group',
    fields: [
      {
        name: 'category',
        label: 'Category',
        type: 'multiselect',
        options: [{label:'attendance', value:'attendance'}, {label:'skill', value:'skill'}, {label:'benchmark', value:'benchmark'}, {label:'nutrition', value:'nutrition'}],
        showInList: true,
        required: true
      },
      {
        name: 'type',
        label: 'Type',
        type: 'multiselect',
        options: [{label:'lifetime', value:'lifetime'}, {label:'year', value:'year'}, {label:'month', value:'month'}],
        showInList: false,
        required: true
      }
    ]
  },
  {
    name: 'description',
    label: 'Description',
    type: 'textarea',
    required: false
  }
];
export default goalSchema;
